import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import splash from '../../media/classroomSplash.jpg'
import { ReactComponent as QuoteIcon } from '../../media/icon-science.svg'
import oftmcssLogo from '../../media/oftmcss.svg'
import { Brand, Content, Indicators, Templates } from 'ui'
import { useCurrentProfile } from './graphql'
import { randomTestimonial } from './testimonials'

/**
 * Displayed when a user completes their profile.
 */
export const ProfileCompleteView: React.FC = () => {
  const { loading, educator, professional } = useCurrentProfile()
  const profile = educator || professional
  const testimonial = randomTestimonial()

  useEffect(() => {
    if (profile && !profile.contentAreas) {
      window.location.href = `/signup/${profile.role}/one`.toLowerCase()
    }
  }, [profile])

  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Your Account is Complete - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        {loading ? (
          <Indicators.Spinner />
        ) : (
          <React.Fragment>
            <Content.Heading>
              Thanks {(profile && profile.firstName) || ''}!
            </Content.Heading>
            <Content.Body>
              Your profile is now complete. We'll notify you with further
              instructions once the Pro Connect platform becomes available.
            </Content.Body>
          </React.Fragment>
        )}
      </Content.Region>
    </Templates.SplashImageView>
  )
}
